import { render, staticRenderFns } from "./client-information-inquiry.vue?vue&type=template&id=6441a71e&scoped=true&"
import script from "./client-information-inquiry.vue?vue&type=script&lang=js&"
export * from "./client-information-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6441a71e",
  null
  
)

export default component.exports